import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { ThemeProvider } from './contexts/theme-context'
import './lib/i18n'
import App from './App'
import './styles/globals.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1,
        },
    },
})

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider defaultTheme="light" storageKey="coffeeback-ui-theme">
                <BrowserRouter>
                    <App />
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                background: '#FDF8F3',
                                border: '1px solid #E5DCD3',
                                color: '#2D1810',
                            },
                        }}
                    />
                </BrowserRouter>
            </ThemeProvider>
        </QueryClientProvider>
    </StrictMode>,
)

